meedy.controller('meedy.messagesListController', ['$scope', '$state', '$sce', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.messagesModel',
    function ($scope, $state, $sce, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, messagesModel) {

        function setData() {
            $scope.messages = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.sortColumns = [{columnName: "id", descending: true}];

            $scope.columns = [
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.MESSAGES.PUBLISH_DATE'),
                    cellTemplate: 'meedy/application/view/app/messages/grid-templates/data-messages-list-date.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.MESSAGES.TITLE'),
                    field: "title"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.MESSAGES.CONTENT'),
                    cellTemplate: 'meedy/application/view/app/messages/grid-templates/data-messages-list-content.html'
                }
            ];

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.MESSAGES.GET_MESSAGES.SUCCESS, function(event, dataPage) {
                $scope.messages = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.viewMessage = function(message) {
                $state.go(Constant.STATE.APP.MEEDY.MESSAGES.VIEW, {id : message.id});
            };

            $scope.htmlToPlaintext = function(text) {
                var res = String(text).replace(/<(?:.|\n)*?>/gm, '');
                //return $sce.trustAsHtml(res);
                return res;
            };

            $scope.criteriaChanged = function() {
                messagesModel.getMessages($scope.criteria);
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.MESSAGES);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.MESSAGES');
        }

        function initialize() {
            messagesModel.getMessages($scope.criteria);
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
